import AmexResyCredit, { ComponentAmexResyCreditUnderTest } from './AmexResyCredit';

export default AmexResyCredit;

export { ComponentAmexResyCreditUnderTest };
